export default __webpack_public_path__ + "static/media/icon-em-pill-type.996e4b43.svg";